import { render, staticRenderFns } from "./CrossCheck.vue?vue&type=template&id=4eb3738c&scoped=true&"
import script from "./CrossCheck.vue?vue&type=script&lang=ts&"
export * from "./CrossCheck.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb3738c",
  null
  
)

export default component.exports